import {getAppBaseUrl} from "../helpers/location"
const webAppConfirmationUri = {
    methods: {
        getWebAppConfirmationUri(routeName) {
            const resetRoute = this.$router.options.routes.filter((r) => r.name === routeName)[0]
            let routePath = ""
            if (resetRoute) {
                routePath = resetRoute.path
            }
            return `${getAppBaseUrl()}#${routePath}`

        }

    }
}


export default webAppConfirmationUri